// material-ui

import variousresourceicon from '../../../assets/images/various-resource.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const VariousResourceIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={variousresourceicon} alt="Various Resource" width="22"  />
    );
};

export default VariousResourceIcon;


